import React, { useEffect, useState } from "react";
import logo from "../../../assets/ultragenyx.png";
import { connect } from "react-redux";
import {
  mapStateToPropsFooter,
  mapStateToPropsLayout,
  mapDispatchToPropsLayout,
} from "../../../modules/layout";
import { mapStateToPropsLogin } from "../../../modules/login";
import moment from "moment";
import styled, { withTheme } from "styled-components";
import { useTranslation } from "react-i18next";
import { urlStudies } from "../../../modules/constants";
import { appStudy } from "../../../config";
import { backendVersion } from "../../../config";

const StyledFooter = styled.footer`
  background-color: ${(props) => props?.theme?.white};
  color: ${(props) => props?.theme?.fg};
  border-top: 17px solid ${(props) => props?.theme?.yellowGreen};

  @media (min-width: 768px) {
    padding-left: ${(props) => (props?.isSidebarExpanded ? "160px" : "80px")};
    &.no-sidebar {
      padding-left: 0px;
    }
  }
`;

const Footer = (props) => {
  const { withSidebar, isLogged, isSidebarExpanded } = props;

  const [backendVersionValue, setBackendVersionValue] = useState("unknown");
  const { t } = useTranslation();

  useEffect(() => {
    (async () => {
      const v = await backendVersion();
      setBackendVersionValue(v);
    })();
  }, []);

  const getMrcpText = () => {
    switch (appStudy.toUpperCase()) {
      case urlStudies.gsdiii:
        return "MRCP-UX053-00009";
      case urlStudies.lcfaod401:
        return "MRCP-UX007-00191";
      case urlStudies.lcfaod302:
        return "MRCP-UX007-00530";
      default:
        return "MRCP-UX007-XXXXX";
    }
  };

  return (
    <StyledFooter
      className={`page-footer font-small indigo pt-3 ${
        withSidebar && isLogged ? "" : "no-sidebar"
      }`}
      isSidebarExpanded={isSidebarExpanded}
    >
      <div className="container-fluid">
        <div className="container-fluid">
          <div className="row">
            <div className="col-sm-4 col-md-3">
              <img
                src={logo}
                alt="logo"
                className="mt-2"
                style={{ height: "50px" }}
              />
            </div>
            <div className="col-sm-4 col-md-6 mt-3 text-center">
              <a
                href="https://www.ultragenyx.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className="block__link small-link"
              >
                {t("appText.footer.privacyPolicy")}
              </a>
              |
              <a
                href="https://www.ultragenyx.com/cookie-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className="block__link small-link"
              >
                {t("appText.footer.cookiePolicy")}
              </a>
              |
              <a
                href="https://www.ultragenyx.com/contact/"
                target="_blank"
                rel="noopener noreferrer"
                className="block__link small-link"
              >
                {t("appText.footer.contact")}
              </a>
            </div>
          </div>
          <hr className="mt-4" />
          <p>{t("appText.footer.message")}</p>
          <p>
            <span data-testid="year-label">
              © {moment().format("YYYY")} Ultragenyx Pharmaceutical Inc.
            </span>
            <span data-testid="mrc-number" className="ms-3">
              {getMrcpText()}
            </span>
          </p>
          {isLogged && (
            <p>
              <span>
                <b>{t("appText.debug.frontendVersion")}</b>{" "}
                {process.env.REACT_APP_VERSION} |{" "}
                <b>{t("appText.debug.backendVersion")}</b> {backendVersionValue}
              </span>
            </p>
          )}
        </div>
      </div>
    </StyledFooter>
  );
};

const mapStateToProps = (state) => ({
  ...mapStateToPropsLayout(state),
  ...mapStateToPropsLogin(state),
});

export default connect(mapStateToProps)(withTheme(Footer));
